export * from './src/keepalive';
export { NgIdleKeepaliveModule } from './src/module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ng-idle/keepalive/index.js
// module id = 263
// module chunks = 3